import { Container, Row, Col } from 'react-bootstrap';
import { useTitle } from '../../context/TitleContext';
import AddOrder from './components/AddOrder';
import '../../styles/products.scss';

const OrderCreate = () => {
  const { setTitle } = useTitle();

  return (
    <Container fluid className="order-create-page">
      <Row>
        <Col xl={12} lg={12}>
          <AddOrder isEdit={false} />
        </Col>
      </Row>
    </Container>
  );
};

export default OrderCreate;
